function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { INPUT } from "../../components/form-styles";
import { PreviewLineButton, loadVoices, voiceList, playAudio, stopAudio, playingKey, subscribePlaying } from "./voices";
import * as api from "./sequences-api";
import { MusicTracks } from "./music-tracks";
import { SxSeg, SxField, SxGroup, SxCheck, SceneThumb, isCard, isMedia, isOverride, kindLabel, voiceSeconds, fmtLen, snap, sixWords, SIZES } from "./sequence-common";

/*
 * Side panel tabs of the sequence editor (mockup screens 3 and 4): Scene (the selected scene), Sound (voice, music,
 * captions) and Look (brand kit, cards, sizes, length target, timing, brief). Exports lives in sequence-outputs.jsx.
 * Every field writes the same storyboard / settings fields the old page did; nothing new goes to the server.
 */

const inp = {
  ...INPUT,
  height: 34,
  padding: "0 10px",
  fontSize: 13.5
};
const area = {
  ...INPUT,
  resize: "vertical",
  fontSize: 13.5,
  lineHeight: 1.45,
  padding: "8px 10px",
  minHeight: 70
};
const FIT_LABELS = {
  auto: "Auto",
  cover: "Fill the frame",
  contain: "Show it all"
};
const SOUND_LABELS = {
  duck: ["Lower it", "Keep the clip's sound, lower under the voice"],
  mute: ["Mute", "No clip sound"],
  keep: ["Keep", "Keep the clip's sound at full level"]
};
const numOrNull = v => v === "" || v === null || v === undefined || isNaN(Number(v)) ? null : Number(v);

/* ============================================================= Scene */
export class ScenePanel extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      rw: false,
      instruction: "",
      more: false,
      removeAsk: false
    });
  }
  componentDidUpdate(prev) {
    if (prev.seg && this.props.seg && prev.seg._key !== this.props.seg._key && (this.state.rw || this.state.removeAsk)) this.setState({
      rw: false,
      removeAsk: false
    });
  }
  render() {
    const {
      seg,
      i,
      n,
      next,
      voice,
      brand,
      disabled,
      canAgent,
      rewriting,
      len,
      minScene,
      onPatch,
      onPatchNext,
      onRewrite,
      onChangeAsset,
      onDuplicate,
      onRemove,
      onMove
    } = this.props;
    if (!seg) return /*#__PURE__*/React.createElement("p", {
      className: "sx-intro"
    }, "No scene selected. Add one with the + on the timeline, or rewrite the cut.");
    const p = patch => onPatch(seg._key, patch);
    const card = isCard(seg);
    const media = isMedia(seg);
    const words = api.wordCount(seg.narration);
    const vs = voiceSeconds(seg);
    const ov = isOverride(seg);
    const go = () => {
      onRewrite(seg, this.state.instruction);
      this.setState({
        rw: false,
        instruction: ""
      });
    };
    const cardP = patch => p({
      card: {
        ...(seg.card || {
          headline: "",
          sub: "",
          style: i === 0 ? "title" : "end"
        }),
        ...patch
      }
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "sx-scene"
    }, /*#__PURE__*/React.createElement("div", {
      className: "sx-shead"
    }, /*#__PURE__*/React.createElement("span", {
      className: "th"
    }, /*#__PURE__*/React.createElement(SceneThumb, {
      seg: seg,
      i: i,
      brand: brand
    })), /*#__PURE__*/React.createElement("span", {
      className: "t"
    }, /*#__PURE__*/React.createElement("b", null, "Scene ", i + 1), /*#__PURE__*/React.createElement("span", null, kindLabel(seg, i), " \xB7 ", fmtLen(len))), !card ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-btn sm",
      disabled: disabled,
      title: "Use another photo or video for this scene. The words stay.",
      onClick: onChangeAsset
    }, "Change") : null), seg.title && !card ? /*#__PURE__*/React.createElement("p", {
      className: "sx-src",
      title: seg.title
    }, seg.title) : null, card ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SxField, {
      label: "First line"
    }, /*#__PURE__*/React.createElement("input", {
      value: seg.card && seg.card.headline || "",
      maxLength: 80,
      disabled: disabled,
      placeholder: i === 0 ? "The title" : "e.g. Visit our site",
      onChange: e => cardP({
        headline: e.target.value
      }),
      style: inp
    })), /*#__PURE__*/React.createElement(SxField, {
      label: "Second line",
      hint: "optional"
    }, /*#__PURE__*/React.createElement("input", {
      value: seg.card && seg.card.sub || "",
      maxLength: 80,
      disabled: disabled,
      placeholder: "e.g. your web address",
      onChange: e => cardP({
        sub: e.target.value
      }),
      style: inp
    }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SxField, {
      label: "Voiceover"
    }, /*#__PURE__*/React.createElement("textarea", {
      rows: 3,
      value: seg.narration,
      disabled: disabled,
      placeholder: "What the voice says over this scene. Leave it empty for no voice.",
      onChange: e => p({
        narration: e.target.value
      }),
      style: area
    })), /*#__PURE__*/React.createElement("div", {
      className: "sx-vrow"
    }, /*#__PURE__*/React.createElement(PreviewLineButton, {
      voice: voice,
      text: seg.narration,
      disabled: disabled,
      label: "Play",
      className: "sx-btn sm"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-btn sm" + (this.state.rw ? " on" : ""),
      disabled: !canAgent || !seg.id || rewriting,
      title: !seg.id ? "Available once this scene has saved" : !canAgent ? "Available when the render finishes" : "Write a fresh line for this scene",
      onClick: () => this.setState({
        rw: !this.state.rw
      })
    }, rewriting ? "Rewriting…" : "Rewrite"), /*#__PURE__*/React.createElement("span", {
      className: "sp"
    }), /*#__PURE__*/React.createElement("span", {
      className: "sx-mute"
    }, words, " word", words === 1 ? "" : "s", words ? ` · about ${fmtLen(vs)}` : "")), this.state.rw ? /*#__PURE__*/React.createElement("div", {
      className: "sx-rw"
    }, /*#__PURE__*/React.createElement("input", {
      value: this.state.instruction,
      autoFocus: true,
      disabled: !canAgent,
      placeholder: "How to change it, e.g. shorter (optional)",
      "aria-label": "How to rewrite this line",
      onChange: e => this.setState({
        instruction: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter") go();
        if (e.key === "Escape") this.setState({
          rw: false
        });
      },
      style: inp
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-go sm",
      disabled: !canAgent || rewriting,
      onClick: go
    }, "Rewrite")) : null, /*#__PURE__*/React.createElement(SxField, {
      label: "Words on screen",
      hint: "up to 6 words"
    }, /*#__PURE__*/React.createElement("input", {
      value: seg.overlayText,
      maxLength: 60,
      disabled: disabled,
      placeholder: "A short line shown over the scene",
      onChange: e => p({
        overlayText: sixWords(e.target.value)
      }),
      style: inp
    }))), /*#__PURE__*/React.createElement(SxGroup, {
      label: "Into the next scene"
    }, next ? /*#__PURE__*/React.createElement(SxSeg, {
      label: "Into the next scene",
      list: api.TRANSITIONS,
      value: next.transitionIn,
      disabled: disabled,
      onChange: v => onPatchNext({
        transitionIn: v
      })
    }) : /*#__PURE__*/React.createElement("span", {
      className: "sx-mute"
    }, "This is the last scene.")), seg.kind === "still" ? /*#__PURE__*/React.createElement(SxGroup, {
      label: "Camera move"
    }, /*#__PURE__*/React.createElement(SxSeg, {
      wrap: true,
      label: "Camera move",
      list: api.MOTIONS,
      value: seg.motion,
      disabled: disabled,
      onChange: v => p({
        motion: v
      })
    })) : null, seg.kind === "still" || seg.kind === "recording" ? /*#__PURE__*/React.createElement(SxGroup, {
      label: "Fit"
    }, /*#__PURE__*/React.createElement(SxSeg, {
      label: "Fit",
      list: api.FITS.map(([k]) => [k, FIT_LABELS[k] || k]),
      value: seg.fit,
      disabled: disabled,
      onChange: v => p({
        fit: v
      })
    })) : null, media ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "sx-two"
    }, /*#__PURE__*/React.createElement(SxField, {
      label: "Start at",
      hint: "seconds"
    }, /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "0",
      step: "0.1",
      value: seg.trimStart || 0,
      disabled: disabled,
      onChange: e => p({
        trimStart: Number(e.target.value) || 0
      }),
      style: inp
    })), /*#__PURE__*/React.createElement(SxField, {
      label: "Stop at",
      hint: seg.mediaSeconds ? `of ${fmtLen(seg.mediaSeconds)}` : "empty = the end"
    }, /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "0",
      step: "0.1",
      value: seg.trimEnd === null || seg.trimEnd === undefined ? "" : seg.trimEnd,
      disabled: disabled,
      placeholder: "the end",
      onChange: e => p({
        trimEnd: numOrNull(e.target.value)
      }),
      style: inp
    }))), /*#__PURE__*/React.createElement(SxGroup, {
      label: "Clip sound"
    }, /*#__PURE__*/React.createElement(SxSeg, {
      label: "Clip sound",
      list: api.AUDIO_MODES.map(([k]) => [k, (SOUND_LABELS[k] || [k])[0], (SOUND_LABELS[k] || [])[1]]),
      value: seg.audioMode,
      disabled: disabled,
      onChange: v => p({
        audioMode: v
      })
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "sx-len"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, "Length"), ov ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: minScene,
      max: "60",
      step: "0.1",
      value: seg.durationSeconds,
      disabled: disabled,
      "aria-label": "Scene length in seconds",
      onChange: e => p({
        durationSeconds: e.target.value === "" ? null : Number(e.target.value)
      }),
      onBlur: e => {
        const v = Number(e.target.value);
        if (!isNaN(v) && v < minScene) p({
          durationSeconds: minScene
        });
      },
      style: {
        ...inp,
        width: 84
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "sx-mute"
    }, "s"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-btn sm",
      disabled: disabled,
      title: "Let the voice decide the length again",
      onClick: () => p({
        durationSeconds: null
      })
    }, card || !seg.narration ? "Automatic" : "Match the voice")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "sx-mute"
    }, card || !seg.narration ? `Automatic · ${fmtLen(len)}` : "Matches the voice"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-btn sm",
      disabled: disabled,
      onClick: () => p({
        durationSeconds: Math.max(minScene, snap(len))
      })
    }, "Set"))), ov && seg.narration && vs > Number(seg.durationSeconds) + 0.05 ? /*#__PURE__*/React.createElement("p", {
      className: "sx-note warn"
    }, "The voice runs about ", fmtLen(vs), ", longer than this scene.") : null, seg.warnings && seg.warnings.length ? /*#__PURE__*/React.createElement("ul", {
      className: "sx-warns"
    }, seg.warnings.map((w, k) => /*#__PURE__*/React.createElement("li", {
      key: k
    }, w))) : null, !card ? /*#__PURE__*/React.createElement("div", {
      className: "sx-chapter"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-fold",
      "aria-expanded": this.state.more || !!seg.chapterTitle,
      onClick: () => this.setState({
        more: !this.state.more
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, this.state.more || seg.chapterTitle ? "expand_more" : "chevron_right"), "Chapter"), this.state.more || seg.chapterTitle ? /*#__PURE__*/React.createElement(SxField, {
      label: "Chapter title",
      hint: "starts a chapter at this scene"
    }, /*#__PURE__*/React.createElement("input", {
      value: seg.chapterTitle,
      maxLength: 120,
      disabled: disabled,
      placeholder: "None",
      onChange: e => p({
        chapterTitle: e.target.value
      }),
      style: inp
    })) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "sx-foot"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-iconbtn",
      disabled: disabled || i === 0,
      "aria-label": "Move this scene earlier",
      title: "Move earlier",
      onClick: () => onMove(i, i - 1)
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "chevron_left")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-iconbtn",
      disabled: disabled || i === n - 1,
      "aria-label": "Move this scene later",
      title: "Move later",
      onClick: () => onMove(i, i + 1)
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "chevron_right")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-btn sm",
      disabled: disabled || n >= api.MAX_PICKS,
      onClick: onDuplicate
    }, "Duplicate"), /*#__PURE__*/React.createElement("span", {
      className: "sp"
    }), this.state.removeAsk ? /*#__PURE__*/React.createElement("span", {
      className: "sx-confirm"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-btn sm danger",
      onClick: () => {
        this.setState({
          removeAsk: false
        });
        onRemove(seg._key);
      }
    }, "Remove"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-btn sm",
      onClick: () => this.setState({
        removeAsk: false
      })
    }, "Keep")) : /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-btn sm danger",
      disabled: disabled || n <= 1,
      title: n <= 1 ? "A sequence keeps at least one scene" : "Remove this scene",
      onClick: () => this.setState({
        removeAsk: true
      })
    }, "Remove scene")));
  }
}

/* ============================================================= Sound */
class VoiceList extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      items: voiceList(),
      loading: true,
      playing: playingKey(),
      all: false
    });
  }
  componentDidMount() {
    this._alive = true;
    this._unsub = subscribePlaying(k => {
      if (this._alive) this.setState({
        playing: k
      });
    });
    loadVoices().then(items => {
      if (this._alive) this.setState({
        items,
        loading: false
      });
    });
  }
  componentWillUnmount() {
    this._alive = false;
    if (this._unsub) this._unsub();
  }
  render() {
    const {
      value,
      onChange,
      disabled
    } = this.props;
    const {
      items,
      loading,
      playing,
      all
    } = this.state;
    const SHORT = 4;
    let shown = all ? items : items.slice(0, SHORT);
    if (!all && value && !shown.some(v => v.id === value)) {
      const cur = items.find(v => v.id === value);
      shown = [...shown.slice(0, SHORT - 1), cur || {
        id: value,
        label: value
      }];
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "sx-voices",
      role: "radiogroup",
      "aria-label": "Voice"
    }, shown.map(v => {
      const [name, ...rest] = String(v.label || v.id).split(" · ");
      const key = `voice:${v.id}`;
      const on = v.id === value;
      const isP = playing === key;
      return /*#__PURE__*/React.createElement("div", {
        key: v.id,
        className: "sx-voice" + (on ? " on" : "")
      }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        name: "sx-voice",
        checked: on,
        disabled: disabled || loading,
        onChange: () => onChange(v.id)
      }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, name), rest.length ? /*#__PURE__*/React.createElement("i", null, " \xB7 ", rest.join(" · ")) : null)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "sx-btn xs" + (isP ? " on" : ""),
        disabled: !v.sampleUrl,
        "aria-label": isP ? `Stop the ${name} sample` : `Play a sample of ${name}`,
        title: v.sampleUrl ? isP ? "Stop" : "Hear a sample" : "No sample for this voice",
        onClick: () => isP ? stopAudio() : playAudio(key, v.sampleUrl)
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, isP ? "stop" : "play_arrow")));
    }), items.length > SHORT ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-link",
      onClick: () => this.setState({
        all: !all
      })
    }, all ? "Fewer voices" : `All ${items.length} voices`) : null, loading ? /*#__PURE__*/React.createElement("span", {
      className: "sx-mute"
    }, "Loading voices\u2026") : null);
  }
}
export class SoundPanel extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      playing: playingKey()
    });
  }
  componentDidMount() {
    this._alive = true;
    this._unsub = subscribePlaying(k => {
      if (this._alive) this.setState({
        playing: k
      });
    });
  }
  componentWillUnmount() {
    this._alive = false;
    if (this._unsub) this._unsub();
  }
  render() {
    const {
      seq,
      disabled,
      captions,
      onSeq,
      onSetting
    } = this.props;
    const musicKey = `music:${seq.musicUrl}`;
    const musicPlaying = this.state.playing === musicKey;
    return /*#__PURE__*/React.createElement("div", {
      className: "sx-sound"
    }, /*#__PURE__*/React.createElement(SxGroup, {
      label: "Voice"
    }, /*#__PURE__*/React.createElement(VoiceList, {
      value: seq.voice,
      disabled: disabled,
      onChange: voice => onSeq({
        voice
      })
    })), /*#__PURE__*/React.createElement(SxGroup, {
      label: "Music"
    }, /*#__PURE__*/React.createElement(SxField, {
      label: "Music file link",
      hint: "an mp3 you have the rights to",
      cls: "sub"
    }, /*#__PURE__*/React.createElement("input", {
      value: seq.musicUrl,
      disabled: disabled,
      placeholder: "https://\u2026",
      onChange: e => onSeq({
        musicUrl: e.target.value
      }, true),
      style: inp
    })), /*#__PURE__*/React.createElement(MusicTracks, {
      value: seq.musicUrl,
      disabled: disabled,
      onChange: url => onSeq({
        musicUrl: url
      })
    }), seq.musicUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "sx-vrow"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "sx-btn sm" + (musicPlaying ? " on" : ""),
      onClick: () => musicPlaying ? stopAudio() : playAudio(musicKey, seq.musicUrl)
    }, musicPlaying ? "Stop" : "Play"), /*#__PURE__*/React.createElement("span", {
      className: "sx-mute"
    }, "Hear the file before you render")), /*#__PURE__*/React.createElement("label", {
      className: "sx-range"
    }, "Level", /*#__PURE__*/React.createElement("input", {
      type: "range",
      min: "0",
      max: "1",
      step: "0.05",
      value: seq.musicVolume,
      disabled: disabled,
      "aria-label": "Music level",
      onChange: e => onSeq({
        musicVolume: Number(e.target.value)
      }, true)
    }), /*#__PURE__*/React.createElement("span", null, Math.round(seq.musicVolume * 100), "%")), /*#__PURE__*/React.createElement(SxCheck, {
      checked: seq.settings.musicDuck !== false,
      disabled: disabled,
      onChange: v => onSetting({
        musicDuck: v
      })
    }, "Lower the music under the voice")) : /*#__PURE__*/React.createElement("span", {
      className: "sx-mute"
    }, "No music. Paste a link or upload your own track.")), /*#__PURE__*/React.createElement(SxGroup, {
      label: "Captions"
    }, /*#__PURE__*/React.createElement(SxCheck, {
      checked: captions,
      disabled: disabled,
      onChange: v => onSetting({
        captions: v,
        captionStyle: v ? seq.settings.captionStyle === "off" ? "brand" : seq.settings.captionStyle : "off"
      })
    }, "Show what is said at the bottom"), captions ? /*#__PURE__*/React.createElement(SxSeg, {
      label: "Caption style",
      list: [["brand", "Brand kit"], ["plain", "Plain"]],
      value: seq.settings.captionStyle === "plain" ? "plain" : "brand",
      disabled: disabled,
      onChange: v => onSetting({
        captionStyle: v
      })
    }) : null, /*#__PURE__*/React.createElement("span", {
      className: "sx-mute"
    }, "Most people watch on mute. Captions sit inside the safe area for each size.")));
  }
}

/* ============================================================= Look */
export function LookPanel({
  seq,
  disabled,
  onSeq,
  onSetting,
  onToggleFormat
}) {
  const st = seq.settings;
  const tc = st.titleCard || null;
  const ec = st.endCard || null;
  const num = (k, fallback, debounced = true) => e => onSetting({
    [k]: e.target.value === "" ? fallback : Number(e.target.value)
  }, debounced);
  return /*#__PURE__*/React.createElement("div", {
    className: "sx-look"
  }, /*#__PURE__*/React.createElement(SxCheck, {
    checked: !!seq.brandKit,
    disabled: disabled,
    onChange: v => onSeq({
      brandKit: v
    })
  }, /*#__PURE__*/React.createElement("b", null, "Use the brand kit"), seq.brand && seq.brand.company ? ` · ${seq.brand.company}` : "", seq.brand && seq.brand.accent ? /*#__PURE__*/React.createElement("i", {
    className: "sx-swatch",
    style: {
      background: seq.brand.accent
    }
  }) : null), /*#__PURE__*/React.createElement(SxGroup, {
    label: "Title card",
    hint: "drawn with the brand kit"
  }, /*#__PURE__*/React.createElement("input", {
    value: tc && tc.headline || "",
    disabled: disabled,
    placeholder: "None",
    "aria-label": "Title card first line",
    onChange: e => onSetting({
      titleCard: e.target.value ? {
        ...(tc || {}),
        headline: e.target.value
      } : null
    }, true),
    style: inp
  }), /*#__PURE__*/React.createElement("input", {
    value: tc && tc.sub || "",
    disabled: disabled || !(tc && tc.headline),
    placeholder: "Second line",
    "aria-label": "Title card second line",
    onChange: e => onSetting({
      titleCard: {
        ...(tc || {}),
        sub: e.target.value
      }
    }, true),
    style: inp
  })), /*#__PURE__*/React.createElement(SxGroup, {
    label: "End card"
  }, /*#__PURE__*/React.createElement("input", {
    value: ec && ec.headline || "",
    disabled: disabled,
    placeholder: "None",
    "aria-label": "End card first line",
    onChange: e => onSetting({
      endCard: e.target.value ? {
        ...(ec || {}),
        headline: e.target.value
      } : null
    }, true),
    style: inp
  }), /*#__PURE__*/React.createElement("input", {
    value: ec && ec.sub || "",
    disabled: disabled || !(ec && ec.headline),
    placeholder: "Second line",
    "aria-label": "End card second line",
    onChange: e => onSetting({
      endCard: {
        ...(ec || {}),
        sub: e.target.value
      }
    }, true),
    style: inp
  })), /*#__PURE__*/React.createElement(SxGroup, {
    label: "Sizes to render",
    hint: "one Render makes each"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sx-sizes"
  }, SIZES.map(([k, name, ratio]) => {
    const f = api.FORMATS.find(([x]) => x === k) || [];
    return /*#__PURE__*/React.createElement(SxCheck, {
      key: k,
      checked: seq.formats.includes(k),
      disabled: disabled,
      onChange: () => onToggleFormat(k)
    }, /*#__PURE__*/React.createElement("b", null, name, " ", ratio), " ", /*#__PURE__*/React.createElement("i", null, f[2] || ""));
  }))), /*#__PURE__*/React.createElement(SxField, {
    label: "Purpose",
    hint: "shapes the next rewrite"
  }, /*#__PURE__*/React.createElement("select", {
    value: seq.purpose,
    disabled: disabled,
    onChange: e => onSeq({
      purpose: e.target.value
    }),
    style: inp
  }, api.PURPOSES.map(([k, l]) => /*#__PURE__*/React.createElement("option", {
    key: k,
    value: k
  }, l)))), /*#__PURE__*/React.createElement(SxField, {
    label: "Length for the next cut",
    hint: "a target, not a limit"
  }, /*#__PURE__*/React.createElement("select", {
    value: st.targetSeconds || 0,
    disabled: disabled,
    onChange: e => onSetting({
      targetSeconds: Number(e.target.value) || null
    }),
    style: inp
  }, api.TARGETS.map(([k, l]) => /*#__PURE__*/React.createElement("option", {
    key: k,
    value: k
  }, l)))), /*#__PURE__*/React.createElement(SxGroup, {
    label: "Timing"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sx-timing"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("span", null, "Transition length"), /*#__PURE__*/React.createElement("input", {
    type: "number",
    min: "0",
    max: "2",
    step: "0.1",
    value: st.transitionSeconds,
    disabled: disabled,
    onChange: num("transitionSeconds", 0),
    style: {
      ...inp,
      width: 76
    }
  }), /*#__PURE__*/React.createElement("i", null, "s")), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("span", null, "Pause at start and end"), /*#__PURE__*/React.createElement("input", {
    type: "number",
    min: "0",
    max: "3",
    step: "0.1",
    value: st.padSeconds,
    disabled: disabled,
    onChange: num("padSeconds", 0),
    style: {
      ...inp,
      width: 76
    }
  }), /*#__PURE__*/React.createElement("i", null, "s")), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("span", null, "Shortest scene"), /*#__PURE__*/React.createElement("input", {
    type: "number",
    min: "1",
    max: "10",
    step: "0.5",
    value: st.minSceneSeconds,
    disabled: disabled,
    onChange: num("minSceneSeconds", 1),
    style: {
      ...inp,
      width: 76
    }
  }), /*#__PURE__*/React.createElement("i", null, "s")))), /*#__PURE__*/React.createElement(SxField, {
    label: "Brief",
    hint: "used by Rewrite the cut"
  }, /*#__PURE__*/React.createElement("textarea", {
    rows: 4,
    value: seq.brief,
    disabled: disabled,
    placeholder: "What the video is for",
    onChange: e => onSeq({
      brief: e.target.value
    }, true),
    style: area
  })), seq.productId ? /*#__PURE__*/React.createElement("span", {
    className: "sx-mute"
  }, "Product: ", seq.productId) : null);
}